import { render } from "./LoadingScreen.vue?vue&type=template&id=305c6642&scoped=true"
import script from "./LoadingScreen.js?vue&type=script&lang=js&external"
export * from "./LoadingScreen.js?vue&type=script&lang=js&external"

import "./LoadingScreen.vue?vue&type=style&index=0&id=305c6642&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305c6642"]])

export default __exports__